import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex",
  style: {"background":"rgba(0,0,0,.7)","position":"relative"}
}
const _hoisted_2 = { class: "mr-auto zi-front" }
const _hoisted_3 = { class: "subtitle-2 text-white text-uppercase" }
const _hoisted_4 = { class: "mx-4 my-4 zi-front" }
const _hoisted_5 = { class: "d-flex align-start mb-2" }
const _hoisted_6 = { class: "flex-grow-1" }
const _hoisted_7 = { class: "title text-primary" }
const _hoisted_8 = { class: "text-caption text-grey-darken-1" }
const _hoisted_9 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_10 = { class: "mb-4 d-flex align-center" }
const _hoisted_11 = {
  class: "d-flex",
  style: {"background":"rgba(0,0,0,.7)","position":"relative"}
}
const _hoisted_12 = { class: "mr-auto zi-front" }
const _hoisted_13 = { class: "subtitle-2 text-white text-uppercase" }
const _hoisted_14 = { class: "mx-4 my-4 zi-front" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_CompositionTree = _resolveComponent("CompositionTree")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.isOpen,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isOpen) = $event)),
    "max-width": "600px"
  }, {
    default: _withCtx(() => [
      (_ctx.alternative && _ctx.relatedProducts.length > 0)
        ? (_openBlock(), _createBlock(_component_v_card, {
            key: 0,
            class: "superset-card"
          }, {
            actions: _withCtx(() => [
              _createVNode(_component_v_btn, {
                class: "ml-auto",
                onClick: _ctx.closeDialog,
                variant: "text",
                icon: "mdi-close"
              }, null, 8, ["onClick"])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", {
                  class: "card-background",
                  style: _normalizeStyle(`background-image: url(${_ctx.getImagePath(_ctx.alternative.image)}); background-size: cover;`)
                }, null, 4),
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.alternative.name), 1),
                  _cache[2] || (_cache[2] = _createElementVNode("div", { class: "font-weight-light text-white text-caption" }, " Product Details ", -1))
                ]),
                _createElementVNode("div", _hoisted_4, [
                  (_ctx.alternative.icon)
                    ? (_openBlock(), _createBlock(_component_v_icon, {
                        key: 0,
                        style: {"color":"white"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.alternative.icon), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode(_component_v_divider, { class: "my-1" }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relatedProducts, (product) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: product.productUri,
                      class: "mb-5 no-mb-last"
                    }, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("b", null, _toDisplayString(product.nameProduct), 1)
                          ]),
                          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.truncateUri(product.productUri)), 1),
                          (product.tagProduct && product.tagProduct.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getDisplayedTags(product), (tag) => {
                                  return (_openBlock(), _createBlock(_component_v_chip, {
                                    key: tag,
                                    size: "x-small",
                                    variant: "outlined",
                                    color: "primary",
                                    class: "mr-1 mb-1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(tag), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128)),
                                (product.tagProduct.length > 5)
                                  ? (_openBlock(), _createBlock(_component_v_chip, {
                                      key: 0,
                                      size: "x-small",
                                      variant: "outlined",
                                      color: _ctx.expandedProductTags[product.productUri] ? 'grey' : 'secondary',
                                      class: "mr-1 mb-1",
                                      onClick: ($event: any) => (_ctx.toggleProductTags(product.productUri)),
                                      style: {"cursor":"pointer"}
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.expandedProductTags[product.productUri])
                                          ? (_openBlock(), _createBlock(_component_v_icon, {
                                              key: 0,
                                              icon: "mdi-chevron-up",
                                              size: "x-small",
                                              class: "mr-1"
                                            }))
                                          : (_openBlock(), _createBlock(_component_v_icon, {
                                              key: 1,
                                              icon: "mdi-chevron-down",
                                              size: "x-small",
                                              class: "mr-1"
                                            })),
                                        _createTextVNode(" " + _toDisplayString(_ctx.expandedProductTags[product.productUri] ? 'Show less' : `+${product.tagProduct.length - 5} more`), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["color", "onClick"]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_v_btn, {
                          size: "small",
                          variant: "outlined",
                          color: "primary",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAllComponents = !_ctx.showAllComponents)),
                          "prepend-icon": _ctx.showAllComponents ? 'mdi-eye' : 'mdi-eye-off'
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.showAllComponents ? 'All Components' : 'Tagged Only'), 1)
                          ]),
                          _: 1
                        }, 8, ["prepend-icon"])
                      ]),
                      _createVNode(_component_CompositionTree, {
                        uri: product.productUri,
                        compositions: _ctx.compositions,
                        showAll: _ctx.showAllComponents,
                        level: 0
                      }, null, 8, ["uri", "compositions", "showAll"])
                    ]))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider)
            ]),
            _: 1
          }))
        : (_ctx.alternative)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 1,
              class: "superset-card"
            }, {
              actions: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  class: "ml-auto",
                  color: "secondary",
                  onClick: _ctx.closeDialog,
                  variant: "text"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                        _createTextVNode("mdi-close")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", {
                    class: "card-background",
                    style: _normalizeStyle(`background-image: url(${_ctx.getImagePath(_ctx.alternative.image)}); background-size: cover;`)
                  }, null, 4),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.alternative.name), 1),
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "font-weight-light text-white text-caption" }, " Product Details ", -1))
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    (_ctx.alternative.icon)
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 0,
                          style: {"color":"white"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.alternative.icon), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode(_component_v_divider, { class: "my-1" }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_alert, {
                      type: "info",
                      variant: "outlined"
                    }, {
                      default: _withCtx(() => _cache[4] || (_cache[4] = [
                        _createTextVNode(" No product information available for this scenario. ")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_divider)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}